module.exports = __webpack_public_path__ + "hyperion-v2-static/img/seerist_sidebar_bg.54970dd7.png";